
const locationData = {
  gcj02:[],
  bd09:[],
  title: "湖南省长沙市高新开发区岳麓大道芯城科技园一期1栋1701"
}

/**
 * 智能打开本地地图（高德 > 百度 > 腾讯 > 系统默认）
 * @param {Object} locationData - 位置数据
 * @param {number[]} locationData.gcj02 - [lng, lat] GCJ-02 坐标（高德/腾讯）
 * @param {number[]} locationData.bd09   - [lng, lat] BD-09 坐标（百度）
 * @param {string} [locationData.title="目的地"] - 地点名称
 */
export function openLocalMap(locationData) {
  const { gcj02, bd09, title = "目的地" } = locationData;
  if (!gcj02 || !bd09 || gcj02.length !== 2 || bd09.length !== 2) {
    console.error("缺少必要坐标数据");
    return;
  }

  const [gcjLng, gcjLat] = gcj02;
  const [bdLng, bdLat] = bd09;

  const schemes = [
    // iosamap://map/marker?position=${gcjLng},${gcjLat}&name=湖南省长沙市高新开发区岳麓大道芯城科技园一期1栋1701
    // 高德地图（国内覆盖率最高，优先）
    {
      name: "高德地图",
      appUrl: `iosamap://map/marker?position=${gcjLng},${gcjLat}&name=${encodeURIComponent(title)}`,
      webUrl: `https://uri.amap.com/marker?position=${gcjLng},${gcjLat}&name=${encodeURIComponent(title)}`
    },
    // 百度地图
    {
      name: "百度地图",
      appUrl: `baidumap://map/marker?location=${bdLat},${bdLng}&title=${encodeURIComponent(title)}&content=${encodeURIComponent(title)}`,
      webUrl: `http://api.map.baidu.com/marker?location=${bdLat},${bdLng}&title=${encodeURIComponent(title)}&output=html`
    },
    // 腾讯地图
    {
      name: "腾讯地图",
      appUrl: `qqmap://map/marker?marker=coord:${gcjLat},${gcjLng};title:${encodeURIComponent(title)}`,
      webUrl: `https://apis.map.qq.com/uri/v1/marker?marker=coord:${gcjLat},${gcjLng}&title=${encodeURIComponent(title)}&referer=myapp`
    },
    // 系统默认地图（geo 协议）
    {
      name: "系统地图",
      appUrl: `geo:${gcjLat},${gcjLng}?q=${gcjLat},${gcjLng}(${encodeURIComponent(title)})`,
      webUrl: `https://www.google.com/maps?q=${gcjLat},${gcjLng}`
    }
  ];

  // === 2. 尝试依次唤起（实际只唤起第一个，其余作为备选逻辑）===
  // 由于无法检测是否安装 App，我们采用“优先尝试高德”，失败则 fallback 到网页
  const primary = schemes[0]; // 默认优先高德

  // 微信环境特殊处理
  // const isWechat = /micromessenger/i.test(navigator.userAgent);
  // if (isWechat) {
  //   // 微信内无法直接唤起 App，弹出提示
  //   if (confirm("微信暂不支持直接打开地图App，请点击【确定】跳转网页版地图，或右上角选择【在浏览器中打开】后重试。")) {
  //     window.open(primary.webUrl, "_blank");
  //   }
  //   return;
  // }

  // === 3. 执行唤起 + fallback ===
  let opened = false;
  const start = Date.now();

  // 尝试打开 App
  window.location.href = primary.appUrl;

  // 如果 1.5 秒内页面未跳转（说明 App 未安装），则跳网页版
  setTimeout(() => {
    if (!opened && Date.now() - start < 2000) {
      window.open(primary.webUrl, "_blank");
    }
  }, 1500);

  // 页面失焦时标记为已打开（部分浏览器支持）
  window.addEventListener('blur', () => {
    opened = true;
  });
}